import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ImplementedProposal } from '../../../api';
import { ProposalCard } from '../../molecules/proposal-card/proposal-card';
import { ProposalModal } from '../../molecules/proposal-modal/proposal-modal';

export const ImplementedProposalsInternational = () => {
  const [openModal, setOpenModal] = useState(false);
  const [activeProposal, setActiveProposal] = useState<Required<ImplementedProposal>>();

  const { t } = useTranslation(['translation', 'implemented-proposals-international']);

  const metrics: {
    highlight: string;
    text: string;
    image: string;
  }[] = t('landing.implementedProposals.metrics', { returnObjects: true });

  const implementedProposals: ImplementedProposal[] = t('implementedProposals', {
    ns: 'implemented-proposals-international',
    returnObjects: true,
  });

  return (
    <div
      className="flex w-[100vw] mt-8 scrollbar-thumb-rounded-full scrollbar-track-rounded-full
                    scrollbar-thumb-bg-700/40 scrollbar-track-transparent scrollbar-thin
                    overflow-x-auto"
    >
      <div className="relative flex">
        {implementedProposals &&
          typeof implementedProposals === 'object' &&
          implementedProposals.map((el, i) => {
            return (
              <ProposalCard
                key={`${el.id}`}
                proposal={el}
                activeProposal={activeProposal}
                activeProposalHandler={setActiveProposal}
                showMoreClickHandler={setOpenModal}
              />
            );
          })}

        <ProposalModal
          modalCloseHandler={setOpenModal}
          openModal={openModal}
          proposal={activeProposal as Required<ImplementedProposal>}
        />
      </div>
    </div>
  );
};
